import axios from '@/lib/axios';

const confirmTrialLens = (data: any) => {
  return axios.post('/facility/orders/trial_lens/confirm', data);
}

export default confirmTrialLens;